import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Users, ShoppingBag, ShieldCheck, Clock, Store, MessageSquare } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// ==================== OVERVIEW TAB ====================
function OverviewTab({ language }) {
  const [stats, setStats] = useState(null);

  useEffect(() => { fetchStats(); }, []);
  const fetchStats = async () => {
    try {
      const { data } = await axios.get(`${API}/admin/stats`);
      setStats(data);
    } catch (e) { console.error(e); }
  };

  if (!stats) return <div className="animate-pulse h-64 bg-white rounded-2xl" />;

  const cards = [
    { label: language === 'lv' ? 'Lietotāji' : 'Users', value: stats.total_users, icon: Users, color: 'text-[#D97736]', bg: 'bg-[#D97736]/10' },
    { label: language === 'lv' ? 'Sludinājumi' : 'Listings', value: stats.active_listings, sub: `/ ${stats.total_listings}`, icon: ShoppingBag, color: 'text-[#4A6B53]', bg: 'bg-[#4A6B53]/10' },
    { label: language === 'lv' ? 'Veikali' : 'Shops', value: stats.total_shops, icon: Store, color: 'text-[#6366f1]', bg: 'bg-[#6366f1]/10' },
    { label: language === 'lv' ? 'Verificēti' : 'Verified', value: stats.verified_shops, icon: ShieldCheck, color: 'text-green-600', bg: 'bg-green-50' },
    { label: language === 'lv' ? 'Gaida apst.' : 'Pending', value: stats.pending_verifications, icon: Clock, color: 'text-amber-600', bg: 'bg-amber-50' },
    { label: language === 'lv' ? 'Ziņas' : 'Messages', value: stats.total_messages, icon: MessageSquare, color: 'text-[#8b5cf6]', bg: 'bg-[#8b5cf6]/10' },
  ];

  return (
    <div data-testid="admin-overview">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
        {cards.map((card, i) => {
          const Icon = card.icon;
          return (
            <div key={i} className="bg-white border border-[#E5E4E0] rounded-2xl p-5">
              <div className={`w-10 h-10 rounded-xl ${card.bg} flex items-center justify-center mb-3`}>
                <Icon className={`w-5 h-5 ${card.color}`} />
              </div>
              <div className="text-2xl font-bold text-[#121212] font-outfit">
                {card.value}{card.sub && <span className="text-sm text-[#5C5C5C] font-normal">{card.sub}</span>}
              </div>
              <div className="text-xs text-[#5C5C5C] mt-1">{card.label}</div>
            </div>
          );
        })}
      </div>

      {/* Category breakdown */}
      <div className="bg-white border border-[#E5E4E0] rounded-2xl p-6">
        <h3 className="font-outfit font-semibold text-[#121212] mb-4">
          {language === 'lv' ? 'Sludinājumi pa kategorijām' : 'Listings by Category'}
        </h3>
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-4">
          {Object.entries(stats.listings_by_category).map(([cat, count]) => {
            const CAT_LABELS = { lv: { shop: 'Veikals', service: 'Pakalpojumi', event: 'Pasākumi', project: 'Projekti', business: 'Uzņēmumi' }, en: { shop: 'Shop', service: 'Services', event: 'Events', project: 'Projects', business: 'Businesses' } };
            return (
              <div key={cat} className="p-4 bg-[#F3F2EE] rounded-xl text-center">
                <div className="text-xl font-bold text-[#121212]">{count}</div>
                <div className="text-sm text-[#5C5C5C]">{CAT_LABELS[language]?.[cat] || cat}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default OverviewTab;
